export const CARTS_STATS_PERIODS = [
  { title: 'Live', value: 'live' },
  { title: 'Weekly', value: 'weekly' },
  { title: 'Monthly', value: 'monthly' },
  { title: 'Yearly', value: 'yearly' },
];